import React from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNav from '../components/BottomNav';

const Upgrade = () => {
  const navigate = useNavigate();
  
  const packages = [
    {
      name: 'Silver',
      price: 'Free',
      features: [
        'Basic member benefits',
        'Newsletter access',
        'Safety deposit box',
        'Community events'
      ],
      route: '/register/silver'
    },
    {
      name: 'Gold',
      price: 'From R500/year',
      features: [
        'All Silver benefits',
        'Concierge services',
        'Priority bookings',
        'Exclusive events',
        'Trading platform access'
      ],
      route: '/register/gold',
      popular: true
    },
    {
      name: 'Supercar Club',
      price: 'Premium',
      features: [
        'All Gold benefits',
        'Supercar fleet access',
        'Track day events',
        'Driving experiences',
        'Exotic vehicle rentals'
      ],
      route: '/register/scc'
    },
    {
      name: 'Privé',
      price: 'From R24,000/year',
      features: [
        'All previous benefits',
        'Fine dining reservations',
        'Private jet access',
        'Yacht charters',
        'Bespoke concierge',
        'Luxury travel planning'
      ],
      route: '/register/prive'
    }
  ];
  
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Upgrade Membership</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Choose Your Premium Experience</p>
        
        <div style={{display: 'grid', gap: '1.5rem', marginTop: '2rem'}}>
          {packages.map((pkg, index) => (
            <div key={index} className="card" style={{position: 'relative'}}>
              {pkg.popular && (
                <div style={{
                  position: 'absolute',
                  top: '-10px',
                  right: '20px',
                  background: 'var(--gold)',
                  color: 'black',
                  padding: '0.25rem 1rem',
                  borderRadius: '20px',
                  fontSize: '0.85rem',
                  fontWeight: 'bold'
                }}>
                  POPULAR
                </div>
              )}
              
              <h2 style={{color: 'var(--gold)', marginBottom: '0.5rem'}}>{pkg.name}</h2>
              <p style={{fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem'}}>
                {pkg.price}
              </p>
              
              <ul style={{listStyle: 'none', padding: 0, marginBottom: '1.5rem'}}>
                {pkg.features.map((feature, i) => (
                  <li key={i} style={{padding: '0.5rem 0', borderBottom: '1px solid rgba(255,255,255,0.1)'}}>
                    ✓ {feature}
                  </li>
                ))}
              </ul>
              
              <button 
                className="btn-primary" 
                style={{width: '100%'}}
                onClick={() => navigate(pkg.route)}
              >
                Upgrade to {pkg.name}
              </button>
            </div>
          ))}
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default Upgrade;
